export default __webpack_public_path__ + "static/mulheres-yanni-3d44897cde9e87f58cbd2637a8334041.png";